import { useId, useState } from "react";


const CollapsibleSection = ({
  eyebrow,
  title,
  description,
  summary,
  defaultOpen = true,
  open,
  onOpenChange,
  children,
  className = "",
}) => {
  const [isOpen, setIsOpen] =
    useState(defaultOpen);

  const controlled = open !== undefined;
  const expanded = controlled ? open : isOpen;

  const toggle = () => {
    const nextOpen = !expanded;
    if (!controlled) setIsOpen(nextOpen);
    onOpenChange?.(nextOpen);
  };

  const contentId = useId();

  return (
    <section
      className={
        "overflow-hidden rounded-2xl border " +
        "border-slate-200 bg-white shadow-sm " +
        className
      }
    >
      <button
        type="button"
        className={
          "flex w-full items-center justify-between " +
          "gap-4 px-5 py-5 text-left " +
          "transition-colors hover:bg-slate-50 " +
          "focus:outline-none focus-visible:ring-2 " +
          "focus-visible:ring-blue-500 " +
          "focus-visible:ring-inset lg:px-6"
        }
        aria-expanded={expanded}
        aria-controls={contentId}
        onClick={toggle}
      >
        <div className="min-w-0">
          {eyebrow && (
            <div
              className={
                "text-xs font-semibold uppercase " +
                "tracking-[0.16em] text-slate-500"
              }
            >
              {eyebrow}
            </div>
          )}

          <div
            className={
              "mt-1 flex flex-wrap items-center gap-3"
            }
          >
            <h2
              className={
                "text-lg font-semibold text-slate-950"
              }
            >
              {title}
            </h2>

            {summary && (
              <span
                className={
                  "rounded-full border border-slate-200 " +
                  "bg-slate-50 px-2.5 py-1 text-xs " +
                  "font-medium text-slate-600"
                }
              >
                {summary}
              </span>
            )}
          </div>

          {description && (
            <p
              className={
                "mt-1 max-w-4xl text-sm leading-6 " +
                "text-slate-500"
              }
            >
              {description}
            </p>
          )}
        </div>

        <div
          className={
            "flex h-9 w-9 shrink-0 items-center " +
            "justify-center rounded-full border " +
            "border-slate-200 bg-white text-slate-600"
          }
        >
          <svg
            viewBox="0 0 24 24"
            fill="none"
            className={
              "h-4 w-4 transition-transform duration-200 " +
              (expanded ? "rotate-180" : "")
            }
            aria-hidden="true"
          >
            <path
              d="M6 9L12 15L18 9"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </div>
      </button>

      {expanded && (
        <div
          id={contentId}
          className={
            "border-t border-slate-200 px-5 py-5 " +
            "lg:px-6 lg:py-6"
          }
        >
          {children}
        </div>
      )}
    </section>
  );
};


export default CollapsibleSection;
